export default "__VITE_ASSET__MJ40AQ9Z__"